 var slider = function (container, options) {
	var slidePosition=0;
	var numOfSlide = $("#slide-holder"+container+" > div").size();
	
	$("#slide-holder"+container).css("width",(numOfSlide*100)+"%");
	$(".slide"+container).css("width",(100/numOfSlide)+"%");
	
	for (var a = 0; a < numOfSlide; a++) {
		$('#slide-nav'+container).append(' <a href="javascript: void(0)" class="slide-nav-bt'+(a===0?' active':'')+'">  </a> ');
	}
	
	$('.slide-nav-bt').click(function() {
		moveSlide($(this));
		clearInterval(autoPlaySlideInter);
	});
	
	function moveSlide(thisa) {
		var thisindex = $('#slide-nav'+container+' a').index(thisa);
		$('#slide-holder'+container).css("margin-left", '-'+thisindex +'00%');
		$('#slide-nav'+container+' a').removeClass('active');
		thisa.addClass('active');
	}
	
	function autoPlaySlide() {
		slidePosition++;
		if (slidePosition == numOfSlide) { slidePosition = 0; }
		moveSlide($("#slide-nav"+container).children(".slide-nav-bt:eq("+slidePosition+")"));
	}
	
	// var autoPlaySlideInter = setInterval(autoPlaySlide,3000);
};